/*
 * Title: Rewards/MobileHeader.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Page title and menu only shows on mobile & tablets
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React, { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { Popover, Transition } from "@headlessui/react";
import logo from "@assets/logo.png";
import close from "@assets/close.png";
import common from "@common/common";
import Management from "@services/management-service";
import { getAppName } from "@helpers/common";
type Props = {
  title : string
};

const MobileHeader: React.FC<Props | any> = (props) => {
  const { actions } = require("@redux/UserRedux");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const management = Management.get();
  const cname = management?.creator?.username;
  const pname = management?.program?.name;

  const togglePopup = () => {
    setIsPopupOpen(prevState => !prevState);
  };

  const handleLogout = () => {
    dispatch(actions.setLogout(true));
    if (getAppName() === "creator") {
      navigate(`/logout`);
    } else {
      navigate(`/${cname}/${pname}/logout`);
    }
    
  };

  return (
    <div className="md:hidden relative z-50">
      <div className="bg-[#FAF8F4] px-[25px] py-6">
        {/* header title & mobile menu start  */}
        <div className="flex items-center justify-between">
          <h4 className="font-normal text-black text-[24px] leading-[31.2px]">
            {props.title}
          </h4>

          {/* menu  */}
          <Popover>
            <Popover.Button onClick={togglePopup} className="outline-none">
            <svg className="h-10 w-10 text-[#000]"  width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">  <path stroke="none" d="M0 0h24v24H0z"/>  <line x1="4" y1="6" x2="20" y2="6" />  <line x1="4" y1="12" x2="20" y2="12" />  <line x1="4" y1="18" x2="20" y2="18" /></svg>

            </Popover.Button>
            <Transition
              as={Fragment}
              enter="duration-200 ease-out"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="duration-100 ease-in"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95">
              <Popover.Panel className="absolute inset-x-0 top-0 z-50 h-screen">
                <div className="flex justify-center h-full bg-[#000]/90">
                  <div className="flex flex-col w-full px-5 space-y-10">
                    <Popover.Button
                    onClick={togglePopup}
                      as="div"
                      className={
                        "flex items-center justify-end mt-10 mr-10 cursor-pointer"
                      }>
                      <img
                        src={close}
                        alt="Menu Close"
                        className="h-[15px] w-[15px] object-contain"
                      />
                    </Popover.Button>
                    <img
                      src={logo}
                      alt="logo"
                      className="h-[35px] w-[228px] object-contain mx-auto"
                    />
                    <div className={`${props.title !== 'Accounts' && 'grow'} flex flex-col justify-center space-y-7`}>
                      { props.title !== 'Accounts' &&
                        <>
                          <Popover.Button as="div" className={"text-center"}>
                            <NavLink
                              to="/touchpoints"
                              className="cursor-pointer text-white text-[24px] font-medium tracking-wider">
                              Touchpoints
                            </NavLink>
                          </Popover.Button>
                          <Popover.Button as="div" className={"text-center"}>
                            <NavLink
                              to="/settings"
                              className="cursor-pointer text-white text-[24px] font-medium tracking-wider">
                              Settings
                            </NavLink>
                          </Popover.Button>
                        </>
                      }
                      <Popover.Button as="div" className={"text-center"}>
                        <div
                          onClick={handleLogout}
                          className="cursor-pointer text-[#f6104e] text-[24px] font-medium tracking-wider"
                        >Log Out</div>
                      </Popover.Button>
                    </div>
                    <div className="grow">
                      <Popover.Button as="div" className={"text-center"}>
                        <a
                          className="cursor-pointer text-white text-[18px] font-normal tracking-wider"
                          rel="noreferrer"
                          href={common.term_of_service_url}
                          target={"_blank"}>
                          Terms and Conditions
                        </a>
                      </Popover.Button>
                      <Popover.Button as="div" className={"text-center mt-4"}>
                        <a
                          className="cursor-pointer text-white text-[18px] font-normal tracking-wider"
                          rel="noreferrer"
                          href={common.privacy_policy_url}
                          target={"_blank"}>
                          Privacy Policy
                        </a>
                      </Popover.Button>
                    </div>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </Popover>
        </div>
      </div>
    </div>
  );
};


export default MobileHeader;
